import script from "./CaptchaHistoria.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptchaHistoria.vue?vue&type=script&setup=true&lang=js"

import "./CaptchaHistoria.vue?vue&type=style&index=0&id=34cbd22a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34cbd22a"]])

export default __exports__